import { h } from 'vue';

export default {
    // functional: true,

    props:
    {
        item: Object,

        divClass: '',
    },

    render()
    {
        return h(
            'div',

            {
                // staticClass: data.staticClass,

                class: [
                    'vh-badge',
                    'vh-badge-primary',
                    'vh-flex-middle',
                    'vh-badge-margin-small-top',
                    this.divClass,
                ],
            },

            [
                h(
                    'div',

                    [
                        h(
                            'i',
                            {
                                class: [
                                    `fa ${this.item.icon}`,
                                    'vh-margin-xsmall-right',
                                ]
                            }
                        ),
                        this.item.value,
                    ],
                ),

                h(
                    'div',
                    {
                        class: 'vh-margin-small-left',
                    },

                    [
                        h(
                            'a',
                            {
                                class: 'vh-link-reset vh-point',
                            },
                            [
                                h(
                                    'i',
                                    {
                                        class: 'bx bx-x',

                                        onClick: () => this.$emit('reset'),
                                    },
                                ),
                            ]
                        ),
                    ]
                ),
            ]
        );
    },
};
